import pure from 'recompose/pure';
import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

/**
 * SvgIcon for a filled in circle. Using the SvGIcon class provided by material-ui so it can be used
 * Inside material UI components like checkboxes.
 * @param {*} props
 */
// eslint-disable-next-line import/no-mutable-exports
let EmptyCircleSvg = props => (
	<SvgIcon {...props}>
		<path d="M3,13a10,10 0 1,0 20,0a10,10 0 1,0 -20,0" />
	</SvgIcon>
);

EmptyCircleSvg = pure(EmptyCircleSvg);
EmptyCircleSvg.displayName = 'EmptyCircle';
EmptyCircleSvg.muiName = 'SvgIcon';

export default EmptyCircleSvg;
